/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ShivaWebSecuredConfiguration } from '../shiva-web-secured-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { createOpcuaConfiguration } from '../fn/opcua-connection/create-opcua-configuration';
import { CreateOpcuaConfiguration$Params } from '../fn/opcua-connection/create-opcua-configuration';
import { exportConnectionTagsOpcuaDefinition } from '../fn/opcua-connection/export-connection-tags-opcua-definition';
import { ExportConnectionTagsOpcuaDefinition$Params } from '../fn/opcua-connection/export-connection-tags-opcua-definition';
import { getOpcuaConfiguration } from '../fn/opcua-connection/get-opcua-configuration';
import { GetOpcuaConfiguration$Params } from '../fn/opcua-connection/get-opcua-configuration';
import { getOpcuaConfigurationTagsValues } from '../fn/opcua-connection/get-opcua-configuration-tags-values';
import { GetOpcuaConfigurationTagsValues$Params } from '../fn/opcua-connection/get-opcua-configuration-tags-values';
import { importConnectionTagsOpcuaDefinition } from '../fn/opcua-connection/import-connection-tags-opcua-definition';
import { ImportConnectionTagsOpcuaDefinition$Params } from '../fn/opcua-connection/import-connection-tags-opcua-definition';
import { listOpcuaConfigurations } from '../fn/opcua-connection/list-opcua-configurations';
import { ListOpcuaConfigurations$Params } from '../fn/opcua-connection/list-opcua-configurations';
import { OpcuaConfig } from '../models/opcua-config';
import { OpcuaConfigList } from '../models/opcua-config-list';
import { removeOpcuaConfiguration } from '../fn/opcua-connection/remove-opcua-configuration';
import { RemoveOpcuaConfiguration$Params } from '../fn/opcua-connection/remove-opcua-configuration';
import { TagsRealtimeDataLastValuesList } from '../models/tags-realtime-data-last-values-list';
import { updateOpcuaConfiguration } from '../fn/opcua-connection/update-opcua-configuration';
import { UpdateOpcuaConfiguration$Params } from '../fn/opcua-connection/update-opcua-configuration';


/**
 * All about the opcua connections
 */
@Injectable({ providedIn: 'root' })
export class OpcuaConnectionService extends BaseService {
  constructor(config: ShivaWebSecuredConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `listOpcuaConfigurations()` */
  static readonly ListOpcuaConfigurationsPath = '/stations/{uid}/opcua';

  /**
   * List a station opcua configurations.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `listOpcuaConfigurations()` instead.
   *
   * This method doesn't expect any request body.
   */
  listOpcuaConfigurations$Response(params: ListOpcuaConfigurations$Params, context?: HttpContext): Observable<StrictHttpResponse<OpcuaConfigList>> {
    return listOpcuaConfigurations(this.http, this.rootUrl, params, context);
  }

  /**
   * List a station opcua configurations.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `listOpcuaConfigurations$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  listOpcuaConfigurations(params: ListOpcuaConfigurations$Params, context?: HttpContext): Observable<OpcuaConfigList> {
    return this.listOpcuaConfigurations$Response(params, context).pipe(
      map((r: StrictHttpResponse<OpcuaConfigList>): OpcuaConfigList => r.body)
    );
  }

  /** Path part for operation `createOpcuaConfiguration()` */
  static readonly CreateOpcuaConfigurationPath = '/stations/{uid}/opcua';

  /**
   * Create a station opcua configuration.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createOpcuaConfiguration()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createOpcuaConfiguration$Response(params: CreateOpcuaConfiguration$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return createOpcuaConfiguration(this.http, this.rootUrl, params, context);
  }

  /**
   * Create a station opcua configuration.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createOpcuaConfiguration$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createOpcuaConfiguration(params: CreateOpcuaConfiguration$Params, context?: HttpContext): Observable<void> {
    return this.createOpcuaConfiguration$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `getOpcuaConfiguration()` */
  static readonly GetOpcuaConfigurationPath = '/stations/{uid}/opcua/{opcuaUid}';

  /**
   * Get a station opcua configuration.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getOpcuaConfiguration()` instead.
   *
   * This method doesn't expect any request body.
   */
  getOpcuaConfiguration$Response(params: GetOpcuaConfiguration$Params, context?: HttpContext): Observable<StrictHttpResponse<OpcuaConfig>> {
    return getOpcuaConfiguration(this.http, this.rootUrl, params, context);
  }

  /**
   * Get a station opcua configuration.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getOpcuaConfiguration$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getOpcuaConfiguration(params: GetOpcuaConfiguration$Params, context?: HttpContext): Observable<OpcuaConfig> {
    return this.getOpcuaConfiguration$Response(params, context).pipe(
      map((r: StrictHttpResponse<OpcuaConfig>): OpcuaConfig => r.body)
    );
  }

  /** Path part for operation `updateOpcuaConfiguration()` */
  static readonly UpdateOpcuaConfigurationPath = '/stations/{uid}/opcua/{opcuaUid}';

  /**
   * update a station opcua configuration.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateOpcuaConfiguration()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateOpcuaConfiguration$Response(params: UpdateOpcuaConfiguration$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return updateOpcuaConfiguration(this.http, this.rootUrl, params, context);
  }

  /**
   * update a station opcua configuration.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateOpcuaConfiguration$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateOpcuaConfiguration(params: UpdateOpcuaConfiguration$Params, context?: HttpContext): Observable<void> {
    return this.updateOpcuaConfiguration$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `removeOpcuaConfiguration()` */
  static readonly RemoveOpcuaConfigurationPath = '/stations/{uid}/opcua/{opcuaUid}';

  /**
   * Remove the station opcua configuration.
   *
   * Remove Opcua configuration
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `removeOpcuaConfiguration()` instead.
   *
   * This method doesn't expect any request body.
   */
  removeOpcuaConfiguration$Response(params: RemoveOpcuaConfiguration$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return removeOpcuaConfiguration(this.http, this.rootUrl, params, context);
  }

  /**
   * Remove the station opcua configuration.
   *
   * Remove Opcua configuration
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `removeOpcuaConfiguration$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  removeOpcuaConfiguration(params: RemoveOpcuaConfiguration$Params, context?: HttpContext): Observable<void> {
    return this.removeOpcuaConfiguration$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `getOpcuaConfigurationTagsValues()` */
  static readonly GetOpcuaConfigurationTagsValuesPath = '/stations/{uid}/opcua/{opcuaUid}/tags';

  /**
   * Get a station opcua configuration tags and values.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getOpcuaConfigurationTagsValues()` instead.
   *
   * This method doesn't expect any request body.
   */
  getOpcuaConfigurationTagsValues$Response(params: GetOpcuaConfigurationTagsValues$Params, context?: HttpContext): Observable<StrictHttpResponse<TagsRealtimeDataLastValuesList>> {
    return getOpcuaConfigurationTagsValues(this.http, this.rootUrl, params, context);
  }

  /**
   * Get a station opcua configuration tags and values.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getOpcuaConfigurationTagsValues$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getOpcuaConfigurationTagsValues(params: GetOpcuaConfigurationTagsValues$Params, context?: HttpContext): Observable<TagsRealtimeDataLastValuesList> {
    return this.getOpcuaConfigurationTagsValues$Response(params, context).pipe(
      map((r: StrictHttpResponse<TagsRealtimeDataLastValuesList>): TagsRealtimeDataLastValuesList => r.body)
    );
  }

  /** Path part for operation `exportConnectionTagsOpcuaDefinition()` */
  static readonly ExportConnectionTagsOpcuaDefinitionPath = '/stations/{uid}/opcua/configuration/{opcuaUid}/export';

  /**
   * Export the OPCUA tags definitions in csv format for a connection.
   *
   * Allows to export the tags definitions, via a XLS File.
   * The connectionUid must be a valid OpcuaUid.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `exportConnectionTagsOpcuaDefinition()` instead.
   *
   * This method doesn't expect any request body.
   */
  exportConnectionTagsOpcuaDefinition$Response(params: ExportConnectionTagsOpcuaDefinition$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return exportConnectionTagsOpcuaDefinition(this.http, this.rootUrl, params, context);
  }

  /**
   * Export the OPCUA tags definitions in csv format for a connection.
   *
   * Allows to export the tags definitions, via a XLS File.
   * The connectionUid must be a valid OpcuaUid.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `exportConnectionTagsOpcuaDefinition$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  exportConnectionTagsOpcuaDefinition(params: ExportConnectionTagsOpcuaDefinition$Params, context?: HttpContext): Observable<Blob> {
    return this.exportConnectionTagsOpcuaDefinition$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /** Path part for operation `importConnectionTagsOpcuaDefinition()` */
  static readonly ImportConnectionTagsOpcuaDefinitionPath = '/stations/{uid}/opcua/configuration/{opcuaUid}/import';

  /**
   * Import the OPCUA tags definitions for a connection.
   *
   * Allows to import the OPCUA tags definitions, via a XLS File.
   * The connectionUid must be a valid OpcuaUid.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `importConnectionTagsOpcuaDefinition()` instead.
   *
   * This method sends `application/vnd.ms-excel` and handles request body of type `application/vnd.ms-excel`.
   */
  importConnectionTagsOpcuaDefinition$Response(params: ImportConnectionTagsOpcuaDefinition$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return importConnectionTagsOpcuaDefinition(this.http, this.rootUrl, params, context);
  }

  /**
   * Import the OPCUA tags definitions for a connection.
   *
   * Allows to import the OPCUA tags definitions, via a XLS File.
   * The connectionUid must be a valid OpcuaUid.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `importConnectionTagsOpcuaDefinition$Response()` instead.
   *
   * This method sends `application/vnd.ms-excel` and handles request body of type `application/vnd.ms-excel`.
   */
  importConnectionTagsOpcuaDefinition(params: ImportConnectionTagsOpcuaDefinition$Params, context?: HttpContext): Observable<void> {
    return this.importConnectionTagsOpcuaDefinition$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
